import styled from '@emotion/styled';
import ArrowIcon from '@/assets/icons/arrow-down.svg?react';

export const DropdownWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
`;

export const DropdownValueContainer = styled.div`
  display: flex;
  align-items: center;
  min-width: 174px;
  max-width: 100%;
  height: 30px;
  padding: 0 10px;
  cursor: pointer;
  user-select: none;
  border: 1px solid #afafaf;
  border-radius: 4px;
  gap: 6px;

  ${({ theme }) => theme.dropdown};
`;

export const ValueText = styled.span`
  flex: auto;
  color: black;
  font-size: 12px;
  font-weight: 500;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const SelectInput = styled.select`
  display: none;
`;

export const Arrow = styled(ArrowIcon)<{ isOpen: boolean }>`
  flex-shrink: 0;
  transform: ${({ isOpen }) => (isOpen ? 'rotate(-180deg)' : 'rotate(0deg)')};
`;

export const DropdownList = styled.ul`
  position: absolute;
  top: calc(100% + 6px);
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  min-width: 174px;
  max-height: 250px;
  padding: 5px 0 !important;
  overflow: auto;
  border: 1px solid #afafaf;
  border-radius: 4px;
  background: #fff;
  box-sizing: border-box;
  z-index: 1;
  gap: 5px;
`;

export const DropdownListItem = styled.li`
  display: flex;
  align-items: center;
  margin: 0 !important;
  min-height: 24px;
  padding: 0 8px;
  color: #000;
  font-size: 12px;
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.colors.light};
  }
`;
